import { IEstabelecimento } from "@/interfaces/IEstabelecimento";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface IEstabelecimentoState {
  items: IEstabelecimento[];
  synced: boolean;
}

const initialState: IEstabelecimentoState = {
  items: [],
  synced: false,
};

const estabelecimentoSlice = createSlice({
  name: "ESTABELECIMENTO",
  initialState,
  reducers: {
    sync: (state, action: PayloadAction<{ items: IEstabelecimento[] }>) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default estabelecimentoSlice.reducer;

export const getEstabelecimentosSynced = (state: RootState) =>
  state.estabelecimento.items;
